import { isPlatform } from '@ionic/react';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics'

export default class FirebaseProvider {
  public provider: any
  static myInstance: FirebaseProvider;

  constructor() { 
    this.provider = FirebaseAnalytics
  }    

  static getInstance(): FirebaseProvider {
    if (FirebaseProvider.myInstance == null) {
      FirebaseProvider.myInstance = new FirebaseProvider();
    }

    return this.myInstance;
  }

  public trackView(screen: string) {
    if(isPlatform('capacitor')) {
      this.provider.setCurrentScreen(screen)
    }
  }

  public trackEvent(name: string, params: any) {
    if(isPlatform('capacitor')){
      this.provider.logEvent(name, params)
    }
  }
}
